// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { BUTLER_POWER_UP_ID } from 'app/scripts/data/butler-id';
import { PluginButtonsView } from 'app/scripts/views/plugin/PluginButtonsView';
import { PluginHeaderButtonView } from 'app/scripts/views/plugin/PluginHeaderButtonView';

class PluginHeaderButtonsView extends PluginButtonsView {
  static initClass() {
    this.prototype.tagName = 'span';
    this.prototype.className = 'board-header-plugin-btns';
    this.prototype.buttonView = PluginHeaderButtonView;
  }
  runnerOptions() {
    //Only need to call butler as pup board buttons have been moved to react
    return {
      plugin: BUTLER_POWER_UP_ID,
      command: 'board-buttons',
      timeout: 10000,
      board: this.model,
    };
  }
}
PluginHeaderButtonsView.initClass();
export { PluginHeaderButtonsView };
